import Button from "@components/Button";
import { Input } from "@components/Input";
import Icon from "@components/Icon";
import { FORGETPASSWORD, RESET_PASSWORD } from "@constants/internal-route.constant";
import { AuthHead, AuthLinks } from "@layout/AuthHead";
import { AuthService } from "@services/api/Auth.service";
import { ToastService } from "@services/utils/toast.service";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function VerifyOtp() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const location = useLocation();

  // Opened without a token (typed URL, reload), state is null: read it defensively so the
  // redirect below can run instead of the destructuring throwing first.
  const token = location?.state?.token;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (!location?.state?.token) {
      navigate(FORGETPASSWORD)
    }
  }, []);

  const navigate = useNavigate();

  const onSubmit = (formData) => {
    setIsLoading(true);
    AuthService.verifyOtp(formData, token)
      .then((res) => {
        navigate(RESET_PASSWORD, {
          state: { token: res.body?.tempToken },
        });
      })
      .catch((err) => ToastService.error(err?.msg))
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <AuthHead title="Enter your code">
        We sent a one-time code to your email or mobile. It’s valid for 5 minutes.
      </AuthHead>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          type="text"
          label="Verification code"
          isRequired
          registerProperty={{
            ...register("otp", { required: "Please enter OTP code" }),
          }}
          isError={!!errors?.otp}
          errorMessage={errors?.otp?.message as string}
        />
        <Button
          className="w-100 mt-2"
          color="primary"
          size="lg"
          type="submit"
          isLoading={isLoading}
          loadingText="Verifying..."
        >
          Verify code
        </Button>
        <AuthLinks>
          <Link to={FORGETPASSWORD}>
            <Icon icon="arrow-left" size={14} /> Use a different email
          </Link>
        </AuthLinks>
      </form>
    </>
  );
}
